import Vue from 'vue';

export class ThemeManager {
  private static readonly THEME_KEY = 'user-theme-preference';
  private static instance: ThemeManager;
  private currentTheme: boolean;
  private vueInstance: Vue;

  private constructor() {
    // Initialize theme from localStorage or default to dark
    this.currentTheme = localStorage.getItem(ThemeManager.THEME_KEY) === 'light' ? false : true;
    this.vueInstance = new Vue({
      data: {
        isDark: this.currentTheme
      }
    });
  }

  public static getInstance(): ThemeManager {
    if (!ThemeManager.instance) {
      ThemeManager.instance = new ThemeManager();
    }
    return ThemeManager.instance;
  }

  public getCurrentTheme(): boolean {
    return this.vueInstance.$data.isDark;
  }

  public setTheme(isDark: boolean): void {
    this.currentTheme = isDark;
    this.vueInstance.$data.isDark = isDark;
    localStorage.setItem(ThemeManager.THEME_KEY, isDark ? 'dark' : 'light');
    
    // Update Vuetify theme
    if (Vue.prototype.$vuetify) {
      Vue.prototype.$vuetify.theme.dark = isDark;
    }
  }

  public toggleTheme(): void {
    this.setTheme(!this.currentTheme);
  }
} 